module.exports = __webpack_public_path__ + "img/symbol_9.dabd8716.png";